module.exports = __webpack_public_path__ + "static/08-4-510ad9a77ccead3adeaeb1401f180d46.jpg";